angular.module('ui.shell')
    .directive('leftPanelView', function (customTemplateResolver) {
        return {
            restrict: 'E',
            replace: 'true',
            templateUrl: 'app/ui/shell/views/leftPanel.html', // customTemplateResolver.get('leftPanel.html', 'app/ui/shell/views/leftPanel.html')
            controller: function ($rootScope, $scope, $state, authService, $element, customResourceResolver, serverInfoService, gettextCatalog) {

                customResourceResolver.resolveConfig('left-panel-custom-links-config', null, {})
                    .then(function (customNavMenuLinks) {
                        $scope.customNavMenuLinks = customNavMenuLinks != null ? customNavMenuLinks : [];
                    });
                serverInfoService.getVersion()
                    .then(function(version) {
                        $scope.serverVersion = _.str.sprintf(gettextCatalog.getString('version %s'), version);
                        $rootScope.serverVersionNumber = version;
                    });

                $element.find('a').click(function () {
                    $element.blur();
                });

                var flyOut = $element.children().first();
                flyOut.click(function () {
                    if ($element.attr('focused')) {
                        $element.removeAttr('focused');
                        $element.blur();
                    } else {
                        $element.attr('focused', true);

                    }
                });
                $element.blur(function () {
                    $element.removeAttr('focused');
                });

                $scope.state = $state;

                $scope.stateGo = function (event, stateToGo) {
                    event.isDefaultPrevented = false;
                    $state.go(stateToGo);
                    return true;
                };

                $scope.logout = function () {
                    authService.logout().then(
                        function (resp) {
                            $state.go('login');
                        },
                        function (resp) {
                            // something goes wrong? Never mind!
                            $state.go('login');
                        });
                };
            }
        };
    });
